// ADAPTADOR DE SAIDA DO PADRAO ATLAS — envolve o serializador que ja existia.
//
// `serializarMovimento` e `nomeArquivoMovimento` continuam sendo a verdade do
// layout v1.0; este arquivo so' os veste na interface de adaptador, para que
// `construirMovimento` tenha um caminho unico. Nao ha uma linha de logica de
// formato aqui — se houvesse, seriam duas fontes para o mesmo arquivo.
//
// O relatorio de geracao do padrao e' o caso feliz: nada somado, ADF escrita,
// nenhum campo sem correspondencia.
import { resumirPorCredor } from "../../movimento-modelo.js";
import { nomeArquivoMovimento, serializarMovimento } from "../../movimento.js";
import { MOVIMENTO_ENCODING } from "../../movimento-layout.js";
import { layoutDoCatalogo } from "../catalogo.js";
const CODIGO = "atlas-movimento";
function versao() {
    return layoutDoCatalogo(CODIGO).versao;
}
export const adaptadorAtlasMovimento = {
    codigo: CODIGO,
    serializar(entrada, _ctx) {
        const texto = serializarMovimento(entrada);
        // FR-023: competencia sem divida nenhuma sai no `casoVazio` declarado — no
        // padrao, ARQUIVO VAZIO, byte a byte como sempre foi — e o relatorio DIZ
        // isso. Sem o aviso, um arquivo de zero bytes e' indistinguivel de falha de
        // geracao para quem le o relatorio depois; o byte a byte nao muda, o que
        // muda e' a explicacao ao lado dele.
        const avisos = entrada.descontos.length === 0
            ? [`a competência ${entrada.competencia} está sem dívidas: o arquivo do movimento sai vazio, sem nenhuma linha`]
            : [];
        return {
            arquivos: [
                {
                    nome: nomeArquivoMovimento(entrada),
                    texto,
                    codificacao: MOVIMENTO_ENCODING,
                    contentType: "text/csv; charset=iso-8859-1",
                },
            ],
            relatorio: {
                layout: { codigo: CODIGO, versao: versao() },
                competencia: entrada.competencia,
                linhas: entrada.descontos.length,
                dividasInstruidas: entrada.descontos.length,
                dividasSomadas: [],
                identificadorEscrito: true,
                camposSemCorrespondencia: [],
                totaisPorCredor: resumirPorCredor(entrada.descontos),
                avisos,
            },
        };
    },
    nomeArquivo(entrada) {
        return nomeArquivoMovimento(entrada);
    },
};
//# sourceMappingURL=atlas-movimento.js.map